const getParsedUrl = (url: string): URL | null => {
  try {
    return new URL(url)
  } catch {
    return null
  }
}

const isDropboxContentHost = (hostname: string): boolean => {
  return hostname.endsWith('.dropboxusercontent.com')
}

export const isDropboxUrl = (url: string): boolean => {
  const parsed = getParsedUrl(url)
  if (!parsed) return false

  const { hostname } = parsed
  return hostname === 'www.dropbox.com'
    || hostname === 'dropbox.com'
    || hostname.endsWith('.dropbox.com')
    || hostname.endsWith('.dropboxusercontent.com')
}

export const isCanadaDropboxUrl = (url: string): boolean => {
  const parsed = getParsedUrl(url)
  if (!parsed) return false

  const { hostname } = parsed
  return hostname === 'dropbox.com'
    || hostname === 'www.dropbox.com'
}

export const isPdfOrAiUrl = (url: string): boolean => {
  const parsed = getParsedUrl(url)
  if (!parsed) return false

  return parsed.pathname.toLowerCase().endsWith('.pdf') || parsed.pathname.toLowerCase().endsWith('.ai')
}

const hasPathExtension = (url: string, extension: string): boolean => {
  const parsed = getParsedUrl(url)
  if (!parsed) return false

  return parsed.pathname.toLowerCase().endsWith(extension)
}

export const getFirstPdfLink = (urls: Array<string | null | undefined>): string | null => {
  for (const url of urls) {
    if (url && isPdfOrAiUrl(url)) return url
  }

  return null
}

export const getPreferredPdfAiLink = (urls: Array<string | null | undefined>): string | null => {
  for (const url of urls) {
    if (url && hasPathExtension(url, '.pdf')) return url
  }

  for (const url of urls) {
    if (url && hasPathExtension(url, '.ai')) return url
  }

  return null
}

const withDropboxFlag = (url: string, key: 'dl' | 'raw', value: '1'): string => {
  const parsed = getParsedUrl(url)
  if (!parsed || !isDropboxUrl(url)) return url

  parsed.searchParams.delete('dl')
  parsed.searchParams.delete('raw')
  parsed.searchParams.set(key, value)
  return parsed.toString()
}

export const getDropboxRenderLink = (url: string): string => {
  const parsed = getParsedUrl(url)
  if (!parsed || isDropboxContentHost(parsed.hostname)) return url

  return withDropboxFlag(url, 'raw', '1')
}

export const getDropboxDownloadLink = (url: string): string => {
  return withDropboxFlag(url, 'dl', '1')
}
